import { render, staticRenderFns } from "./famous.vue?vue&type=template&id=3c27e77b&scoped=true&"
import script from "./famous.vue?vue&type=script&lang=js&"
export * from "./famous.vue?vue&type=script&lang=js&"
import style0 from "./famous.vue?vue&type=style&index=0&id=3c27e77b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27e77b",
  null
  
)

export default component.exports